import React from 'react';
import LegendSection from 'components/Common/LegendSection';

export default function Legend() {
  return (
    <div
      style={{
        height: '50px',
        background: '#fcfdfe',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0',
        boxShadow: '0 -1px 2px 0 rgba(0, 0, 0, 0.05)',
      }}
    >
      <LegendSection
        title="Legends"
        items={[
          { label: 'Bronze Dataset', color: '#a67c00' },
          { label: 'Silver Dataset', color: '#707593' },
          { label: 'Gold Dataset', color: '#ff9f00' },
          { label: 'Business App', color: '#42adf0' },
          { label: 'Databricks', color: '#00ba7c' },
          { label: 'Pipeline', color: '#ff8000' },
        ]}
      />
      <LegendSection
        title="Clusters"
        items={[
          { label: 'Dataset', color: '#f092c1' },
          { label: 'Notebook', color: '#b0a0e0' },
          { label: 'DQ Suite', color: '#87ab56' },
          { label: 'Recon Suite', color: '#8da9e6' },
        ]}
      />
      <LegendSection
        title="Connectors"
        isConnectors
        items={[
          { label: 'Success', color: '#00b300' },
          { label: 'Failed', color: '#ff0000' },
          { label: 'In Progress', color: '#ffbf00' },
          { label: 'Scheduled', color: '#8e8eb3' },
        ]}
      />
    </div>
  );
}
